import { render, staticRenderFns } from "./ShowSingle.vue?vue&type=template&id=13097f4d&"
import script from "./ShowSingle.vue?vue&type=script&lang=js&"
export * from "./ShowSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports